interface UsageIndicatorProps {
  current: number;
  limit: number;
  label?: string;
  showPercentage?: boolean;
}

export function UsageIndicator({
  current,
  limit,
  label = 'Requests',
  showPercentage = true,
}: UsageIndicatorProps) {
  const isUnlimited = limit === -1 || limit === Infinity;
  const percentage = isUnlimited ? 0 : Math.min((current / limit) * 100, 100);

  const getBarColor = () => {
    if (isUnlimited) return 'bg-primary-500';
    if (percentage >= 90) return 'bg-red-500';
    if (percentage >= 75) return 'bg-yellow-500';
    return 'bg-primary-500';
  };

  const formatNumber = (num: number): string => {
    if (num >= 1000000) return `${(num / 1000000).toFixed(1)}M`;
    if (num >= 1000) return `${(num / 1000).toFixed(1)}K`;
    return num.toString();
  };

  return (
    <div className="w-full">
      <div className="flex justify-between items-center mb-1">
        <span className="text-sm font-medium text-gray-700">{label}</span>
        <span className="text-sm text-gray-500">
          {formatNumber(current)} / {isUnlimited ? 'Unlimited' : formatNumber(limit)}
          {showPercentage && !isUnlimited && (
            <span className="ml-1">({percentage.toFixed(0)}%)</span>
          )}
        </span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-2">
        <div
          className={`${getBarColor()} h-2 rounded-full transition-all duration-300`}
          style={{ width: isUnlimited ? '100%' : `${percentage}%` }}
        />
      </div>
      {percentage >= 90 && !isUnlimited && (
        <p className="text-xs text-red-600 mt-1">
          Approaching limit. Consider upgrading your plan.
        </p>
      )}
    </div>
  );
}

export default UsageIndicator;
